import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 導入語言資源
import zhTW from './locales/zh-HK.json';
import zhCN from './locales/zh-CN.json';
import en from './locales/en.json';

const resources = {
  'zh-TW': {
    translation: zhTW
  },
  'zh-CN': {
    translation: zhCN
  },
  'en': {
    translation: en
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh-TW', // 預設語言
    debug: process.env.NODE_ENV === 'development',

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React 已經處理了 XSS 防護
    },

    react: {
      useSuspense: false, // 避免在 SSR 中出現問題
    }
  });

export default i18n;
